import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  getImportBillById,
  getImportBillByIdToReturn,
  getImportItemById,
} from "../../../services/Import";
import InputField from "../../../FormComponents/InputField";
import { getUser } from "../../../Utils/Common";
import FormAlert from "../../../components/FormAlert";
import ItemSelectingPopup from "../../../components/ItemSelectingPopup";
import Validation from "../../../Validation/ImportReturnBillValidation";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import ReturnBillItemComponent from "../../../components/ReturnBillItemComponent";

import StoreIcon from "@mui/icons-material/Store";
import TagIcon from "@mui/icons-material/Tag";
import Im_returnBillConfirmation from "./Im_returnBillConfirmation";

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius * 1.5,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(3),
  boxShadow: "0 8px 16px 0 rgba(0,0,0,0.1)",
}));

function Im_returnBill() {
  const history = useHistory();
  const { billId } = useParams();

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [openConfimation, setOpenConfirmation] = React.useState(false);
  const [billData, setBillData] = React.useState({});
  const [isLoading, setLoading] = useState(false);
  const [billItemSet, setBillItemSet] = useState([]);
  const [billItemValidatingSet, setBillItemValidatingSet] = useState([]);

  //display alert...
  const [displayAlert, setAlert] = useState(false);

  //alert data
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  //for input feild values
  const [values, setValues] = useState({
    _billNo: "",
    _billNote: "",
  });

  //dataset for bills
  const [bills, setBills] = useState([]);

  // set open table
  const [openTable, setOpenTable] = useState(false);

  // errors for inputfeild
  const [error, setError] = useState({});

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getImportBillByIdToReturn(billId);
      if (result) {
        result.billNo = result.billNo + "-R";
        setBillData(result);
        const billItems = result.import_billItems || [];
        setBillItemSet(billItems);
        setBillItemValidatingSet(billItems);
      } else {
        setError({
          ...error,
          _billDataError: "Unable to fetch bill data",
        });
      }
    } catch (error) {
      console.error("Error fetching bill data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [billId]);

  //Reset values
  const resetValues = () => {
    closeAlert();
    setSelectedItems([]);
    setValues({
      _billNo: "",
      _billNote: "",
    });
  };

  // Alerts ////////////////////////////////////
  const closeAlert = () => {
    setAlert(false);
    setAlertData({
      type: "",
      message: "",
    });
  };

  //////////////////////////////////////////////

  const handleChange = (name, val) => {
    console.log(name, val);

    setValues({
      ...values,
      [name]: val,
    });
  };

  //columns for selected table for return bill
  const selectedColumnsForReturn = [
    { id: "item", label: "Item", minWidth: 100, editable: false },
    { id: "brand", label: "Brand", minWidth: 100, editable: false },
    {
      id: "qty",
      label: "Qty",
      minWidth: 100,
      editable: true,
      type: "number",
      isDecimal: false,
    },
    { id: "billUnit", label: "Bill Unit", minWidth: 100, editable: true },
    { id: "unitType", label: "Unit", minWidth: 100, editable: false },
    {
      id: "itemUintsPerBillUnit",
      label: "Item Units Amount",
      minWidth: 100,
      editable: true,
      type: "number",
      isDecimal: true,
    },
  ];

  const handleCloseTable = async () => {
    setOpenTable(false);
    const selectedArray = [];
    console.log("selectedItems", selectedItems);
    for (let x = 0; x < selectedItems.length; x++) {
      let importItem = await getImportItemById(selectedItems[x]);
      console.log("importItem", importItem);
      selectedArray.push(
        createDataForSelectedTable(
          importItem.itemName + "(" + importItem.product_code + ")",
          importItem.brand,
          0.0,
          importItem.unitType,
          importItem.unitType,
          0.0,
          0.0,
          0.0,
          0.0,
          importItem.importId,
          importItem.qty
        )
      );
    }
    console.log("selectedArray", selectedArray);
    setSelectedRows(selectedArray);
    console.log("Selected Rows", selectedRows);
  };

  function createDataForSelectedTable(
    item,
    brand,
    qty,
    billUnit,
    unitType,
    itemUintsPerBillUnit,
    unitPrice,
    discountPerItem,
    price,
    importId,
    existingQty
  ) {
    return {
      item,
      brand,
      qty,
      billUnit,
      unitType,
      itemUintsPerBillUnit,
      unitPrice,
      discountPerItem,
      price,
      importId,
      existingQty,
    };
  }

  const submitValue = async () => {
    console.log("Bill item data: ", billItemSet);

    let billBody = {
      addedBy: getUser().username,
      importBillId: billId,
      billNo: billData.billNo + "-R",
      shop: billData.shop,
      billType: "RETURN BILL",
      note: values._billNote,
      import_billItems: billItemSet,
    };

    const validationErrors = Validation(billItemSet);
    setError(Validation(billItemSet));
    console.log("Validation function output:", validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setBillData(billBody);
      setOpenConfirmation(true);
      console.log("confirmation", openConfimation);
    }
  };

  return openConfimation ? (
    <Im_returnBillConfirmation
      billData={billData}
      setOpenConfirmation={setOpenConfirmation}
    />
  ) : (
    <HeaderCard>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={11} sx={12}>
          <Typography mt={1} variant="h6">
            {" "}
            Return Import Bill{" "}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1} sx={12}>
          <Tooltip title="Close">
            <IconButton
              onClick={() => history.goBack()}
              aria-label="close"
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card elevation={1} sx={{ height: "100%", borderRadius: 2 }}>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <TagIcon sx={{ mr: 1, color: "primary.main" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight="700"
                  color="primary.main"
                >
                  Bill Information
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Bill Number
                  </Typography>
                  <Typography variant="body1" fontWeight="600">
                    {billData.billNo}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Shop
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <StoreIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                    <Typography variant="body1">{billData.shop}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} sx={12}>
          {billItemSet.length !== 0 ? (
            <ReturnBillItemComponent
              billItems={billItemSet}
              setBillItemSet={setBillItemSet}
              qtyValidatingSet={billItemValidatingSet}
              setQtyValidatingSet={setBillItemValidatingSet}
            />
          ) : null}
        </Grid>
        <Grid item xs={12} sm={12} sx={12}>
          <Typography
            align="left"
            variant="caption"
            style={{
              color: "red",
              fontSize: 16,
              fontWeight: "bold",
              paddingLeft: 40,
            }}
          >
            {error._items}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={9} sx={12}>
          <InputField
            name="_billNote"
            value={values._billNote}
            onChange={(event, newInputValue) => handleChange(event, newInputValue)}
            type="text"
            label="Note"
            multiline={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} sx={12}>
          {displayAlert ? (
            <FormAlert type={alertData.type} message={alertData.message} />
          ) : null}
        </Grid>
        <Grid item xs={12} sm={12} sx={12}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} sm={4} sx={12}>
              <Button fullWidth variant="contained" onClick={submitValue}>
                Create
              </Button>
            </Grid>
            <Grid item xs={12} sm={1} sx={12}>
              <Button onClick={resetValues} variant="outlined">
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          {openTable ? (
            <ItemSelectingPopup
              setOpenTable={setOpenTable}
              openTable={openTable}
              handleCloseTable={handleCloseTable}
              setSelectedItems={setSelectedItems}
              selectedItems={selectedItems}
              setRows={setRows}
              rows={rows}
            />
          ) : null}
        </Grid>
      </Grid>
    </HeaderCard>
  );
}

export default Im_returnBill;
